import { RoundNumberInput } from "@foodpilot/foods";

type InputBoxProps = {
    value: string | undefined;
    unit: string;
    updateActivities: (newValue: string) => void;
};

export const InputBox = (props: InputBoxProps) => (
    <RoundNumberInput
        placeholder={"0"}
        value={props.value}
        unit={props.unit}
        onChange={(e) => {
            props.updateActivities(e.target.value);
        }}
    />
);
